<template>

  <div class="app-page">
    <!--<div class="app-page-header">
      <img src="../assets/login/back.png" style="visibility: hidden"/>
      <span class="title">智能信息发布设备安装</span>
      <img src="../assets/login/back.png" style="visibility: hidden"/>
    </div>-->
    <div class="app-page-content">
      <div class="app-card">
        <div class="container">
          <div class="box">
            <img src="../assets/login/logo.png" class="logo"/>
            <form class="myForm" @submit="send">
              <div class="form-item">
                <img src="../assets/login/user.png" class="form-icon"/>
                <input type="text" name="name" class="xc-btn" placeholder="请输入账号"/>
              </div>
              <div class="form-item">
                <img src="../assets/login/password.png" class="form-icon"/>
                <input type="password" name="pwd" class="xc-btn" placeholder="请输入密码"/>
              </div>
              <div class="form-item">
                <!--<button type="submit" class="xc-btn">登录</button>-->
                <input type="submit" class="xc-btn xc-submit" value="登录"/>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import loadScript from '../utils/load-script'

export default {
  name: 'login',
  data(){
    return{
      // devicecode:this.$route.query.devicecode,
    }
  },
  async created() {
    await loadScript('/libs/md5.js')
    console.log(this.$store.state.devicecode)
    /*if(this.devicecode!=undefined){
      //存储设备序列号
      this.$store.dispatch("setDeviceCode",this.devicecode);
    }*/
  },
  methods: {
    send:function (e) {
      var _this=this;
      e.preventDefault();
      var myForm=e.target;
      var userName=myForm.name.value;
      var password=myForm.pwd.value;
      if(userName==""){
        this.$message.warning("账号不能为空");
        return;
      }
      if(password==""){
        this.$message.warning("密码不能为空");
        return;
      }
    //  验证登录合法性
      this.$http.post("/h5login",{
        userName:userName,
        password:window.md5(password)
      },{
        needLogin:false,
      }).then(function (res) {
        //存储token
        // _this.$store.dispatch("setToken",res.data.token);
        localStorage.token = res.data.token;
        //  跳转到绑定页面
        _this.$router.push("./bindDevice")
      }).catch(function (result) {
        console.log(result)
      })
    },
  },

}
</script>

<style lang="scss">
  .app-page-content{
    .container{
      /*height: calc(100vh - 48px);*/
      height: 100vh;
      background: url("../assets/login/bg.jpg");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .box{
        width: 250px;
        height: 343px;
        .logo{
          height: 114px;
        }
        .myForm{
          margin-top: 59px;
          .form-item{
            width: 100%;
            height: 45px;
            border-radius: 22.5px;
            border: solid 1px #d2d2d2;
            padding: 0 17.5px;
            display: flex;
            align-items: center;
            margin-bottom: 17.5px;
            &:last-of-type{
              background-color: #1655bf;
            }
            .form-icon{
              height: 17px;
              margin-right: 10px;
            }
            input{
              height: 98%;
              padding: 0;
              border: 0;
              font-size: 16.5px;
              color: #333333;
            }
            .xc-submit{
              color: #ffffff;
              background-color: #1655bf;
            }
          }
        }
      }
    }
  }
</style>
